import React, { useState } from "react";
import { getUser } from "../auth/auth";
import { useTranslation } from "react-i18next";

export default function Profile() {
    const { t } = useTranslation();
    const user = getUser();

    const [formData, setFormData] = useState({
        name: user?.name || "",
        email: user?.email || "",
        password: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // إرسال البيانات للـ API
        alert(t("profile_updated"));
    };

    return (
        <div className="container py-5 mb-5" style={{ minHeight: "70vh" }}>
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                    <div className="card border-0 shadow-sm p-4 p-md-5">

                        <div className="text-center mb-4">
                            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3 shadow-sm" style={{ width: "80px", height: "80px" }}>
                                <i className="bi bi-person-fill fs-1"></i>
                            </div>
                            <h3 className="fw-bold text-dark">{t("profile_title")}</h3>
                            <p className="text-muted">{t("profile_desc")}</p>
                        </div>

                        <form onSubmit={handleSubmit}>
                            {/* الاسم */}
                            <div className="mb-3">
                                <label className="form-label fw-bold">{t("contact_name")}</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-0"><i className="bi bi-person"></i></span>
                                    <input type="text" name="name" className="form-control bg-light border-0" value={formData.name} onChange={handleChange} required />
                                </div>
                            </div>

                            {/* الإيميل */}
                            <div className="mb-3">
                                <label className="form-label fw-bold">{t("contact_email")}</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-0"><i className="bi bi-envelope"></i></span>
                                    <input type="email" name="email" className="form-control bg-light border-0" value={formData.email} onChange={handleChange} required />
                                </div>
                            </div>

                            {/* الباسورد */}
                            <div className="mb-4">
                                <label className="form-label fw-bold">{t("profile_pass")}</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-0"><i className="bi bi-lock"></i></span>
                                    <input type="password" name="password" className="form-control bg-light border-0" placeholder="••••••••" value={formData.password} onChange={handleChange} />
                                </div>
                                <small className="text-muted mt-1 d-block">{t("profile_pass_hint")}</small>
                            </div>

                            <button type="submit" className="btn btn-primary btn-lg w-100 fw-bold shadow-sm">
                                <i className="bi bi-save me-2"></i> {t("profile_save")}
                            </button>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
}